import mbtn from "./assets/mint.png";
import cbtn from "./assets/connect.png";
import twitter from "./assets/twitter.png";
import opensea from "./assets/opensea.png";
import discord from "./assets/discord.png";
import { useState } from "react";
import { useContext, useEffect } from "react";
import { BlockchainContext } from "./context/BlockchainContext";

function App() {
  const [mintAmount, setMint] = useState(1);
  const [mintCost, setMintCost] = useState();
  const {
    error,
    mint,
    cost,
    totalSupply,
    totalSupplym,
    setErrorMessage,
    phase,
    presalemint,
    limit,
    whitelistmint,
    currentSignerAddress,
    hbal,
    nft,
  } = useContext(BlockchainContext);
  const [feedback, setFeedback] = useState("");
  const { connectWallet } = useContext(BlockchainContext);
  const connectHandler = async () => {
    await connectWallet();
  };
  const mintHandler = async () => {
    if (currentSignerAddress.toString() === "") {
      await connectWallet();
    } else {
      setFeedback("Processing...");
      if (phase === 1) {
        let msg = "SALE HAS NOT STARTED YET";
        setFeedback(msg);
      } else if (phase === 2) {
        console.log(mintAmount);
        const tx = await mint(mintAmount);
        if (tx === 1) {
          setFeedback("Minting Successful");
        } else {
          setFeedback(tx);
          console.log("feedback :", tx);
        }
      }
    }
  };
  useEffect(() => {
    if (totalSupplym > 2500) {
      setMintCost(parseFloat(cost * mintAmount).toFixed(3));
    } else {
          setMintCost(0);
        }
      
      }
  );

  return (
    <div className="App">
      <div>
        <div className="connect-btn">
          <a href="https://twitter.com/dos_apes" target="_blank">
            <img className="social" src={twitter} alt="twitter" />
          </a>
          <a href="https://opensea.io/collection/dos-apes-1" target="_blank">
            <img className="social" src={opensea} alt="opensea" />
          </a>
        </div>

        <main>
          <div className="logo">
            <h2>DOS APES</h2>
          </div>
          <div className="mint-container row">
            <div className="col-sm-4 text-end"></div>
            <div className="col-sm-4 align-self-center">
              <h6 className="text">{totalSupply}/10000</h6>
              <div className="mintQty">
                <button
                  className="btn"
                  onClick={() => mintAmount > 1 && setMint(mintAmount - 1)}
                >
                  -
                </button>
                <div className="fs-2 text-white mt-3">{mintAmount}</div>
                <button
                  className="btn"
                  onClick={() => mintAmount <= 9 && setMint(mintAmount + 1)}
                >
                  +
                </button>
              </div>

              {currentSignerAddress.toString() !== "" ? (
                <>
                  <button className="btn" onClick={mintHandler}>
                    MINT
                  </button>
                  <h5 className="text1">
                    {" "}
                    <br />
                    Total Price: {mintCost} Eth
                  </h5>
                </>
              ) : (
                <>
                  <button className="btn" onClick={connectHandler}>
                    CONNECT
                  </button>

                  <h5 className="text-white"> </h5>
                </>
              )}
              <h5 className="text-white">
                {" "}
                <br />
                {feedback}
              </h5>
            </div>
            <div className="col-sm-4 text-start"></div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
